import React, { useState, useEffect } from "react";
import { FormControl, InputLabel, MenuItem, Select, Chip } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

const LanguageSelector = ({
  professionalDetails,
  handleProfessionalChange,
}) => {
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const response = await fetch("https://restcountries.com/v3.1/all?fields=languages");
        const data = await response.json();
        const languageSet = new Set();

        data.forEach((country) => {
          if (country.languages) {
            Object.values(country.languages).forEach((language) => {
              languageSet.add(language);
            });
          }
        });

        setLanguages(Array.from(languageSet).sort());
        setLoading(false);
      } catch (error) {
        console.error("Error fetching languages:", error);
        setLoading(false);
      }
    };

    fetchLanguages();
  }, []);

  return loading ? (
    <CircularProgress />
  ) : (
    <FormControl fullWidth required>
      <InputLabel id="specialization-label">Languages</InputLabel>
      <Select
        id="languages"
        name="languages"
        label="Languages"
        variant="outlined"
        required
        fullWidth
        multiple
        value={professionalDetails.languages.split(", ").filter(Boolean)}
        onChange={handleProfessionalChange}
        renderValue={(selected) => (
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {selected.map((value) => (
              <Chip key={value} label={value} style={{ margin: 2 }} />
            ))}
          </div>
        )}
      >
        {languages.map((language) => (
          <MenuItem key={language} value={language}>
            {language}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSelector;
